const routes = [
  // {
  //   path: "/basicSetting",
  //   name: authCodeMap.baseData,
  //   component: (): any => import("@/modules/router.vue"),
  //   redirect: "/basicSetting",
  //   meta: {
  //     title: "基本设置",
  //     hidden: false,
  //     icon: "tree",
  //     needLogin: true,
  //     authCode: authCodeMap.basicSetting,
  //   },
  //   children: [
  //     {
  //       path: "account",
  //       name: authCodeMap.basicSetting_account,
  //       component: (): any => import("@/modules/basicSetting/pages/account/index.vue"),
  //       meta: {
  //         title: "管理_成员管理",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.basicSetting_account,
  //       },
  //     },
  //     {
  //       path: "setting",
  //       name: authCodeMap.basicSetting_setting,
  //       component: (): any => import("@/modules/basicSetting/pages/setting/index.vue"),
  //       meta: {
  //         title: "管理_参数设置",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.basicSetting_setting,
  //       },
  //     },
  //     {
  //       path: authCodeMap.basicSetting_setting_doctorActivity,
  //       name: authCodeMap.basicSetting_setting_doctorActivity,
  //       component: (): any => import("@/modules/basicSetting/pages/setting/doctorActivity.vue"),
  //       meta: {
  //         title: "活动设置",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.basicSetting_setting_doctorActivity,
  //       },
  //     },
  //     {
  //       path: authCodeMap.basicSetting_setting_doctorJoinComunnity,
  //       name: authCodeMap.basicSetting_setting_doctorJoinComunnity,
  //       component: (): any => import("@/modules/basicSetting/pages/setting/doctorJoinComunnity.vue"),
  //       meta: {
  //         title: "管理_参数设置",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.basicSetting_setting_doctorJoinComunnity,
  //       },
  //     },
  //     {
  //       path: "news",
  //       name: authCodeMap.basicSetting_news,
  //       component: (): any => import("@/modules/basicSetting/pages/news/index.vue"),
  //       meta: {
  //         title: "管理_消息中心",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.basicSetting_news,
  //       },
  //     },
  //     {
  //       path: "permission",
  //       name: authCodeMap.basicSetting_permission,
  //       component: (): any => import("@/modules/basicSetting/pages/permission/index.vue"),
  //       meta: {
  //         title: "管理_权限管理",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.basicSetting_permission,
  //       },
  //     },
  //     {
  //       path: "role",
  //       name: authCodeMap.basicSetting_role,
  //       component: (): any => import("@/modules/basicSetting/pages/role/index.vue"),
  //       meta: {
  //         title: "管理_角色管理",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.basicSetting_role,
  //       },
  //     },
  //     {
  //       path: "addRole",
  //       name: authCodeMap.basicSetting_addRole,
  //       component: (): any => import("@/modules/basicSetting/pages/addRole/checkIndex.vue"),
  //       meta: {
  //         title: "管理_添加角色",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.basicSetting_addRole,
  //       },
  //     },
  //     {
  //       path: "agreement",
  //       name: authCodeMap.basicSetting_agreement,
  //       component: (): any => import("@/modules/basicSetting/pages/agreement/index.vue"),
  //       meta: {
  //         title: "管理_用户协议",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.basicSetting_addRole,
  //       },
  //     },
  //     {
  //       path: "bind",
  //       name: authCodeMap.basicSetting_bind,
  //       component: (): any => import("@/modules/basicSetting/pages/bind/index.vue"),
  //       meta: {
  //         title: "管理_用户协议",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.basicSetting_addRole,
  //       },
  //     },
  //   ],
  // },
];
export default routes;